import React from "react";
import "./Results.css";
import Meanings from "./Meanings";
import { useLocation } from "react-router";

export default function Results() {
  const location = useLocation();
  const data = location.state?.resultData;
  const url = location.state?.ImageUrl;
  console.log("dictionary api:", data);

  function capitalize(value) {
    if (value === null || value === undefined) {
      return "";
    } else {
      const string = String(value);
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }

  return (
    <div
      className="Container p-5 my-4 d-flex justify-content-center"
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.8),rgba(255,255,255,0.7)),url(${url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        boxShadow:
          "rgb(170, 170, 175, 0.6) -5px 4px 6px inset, rgb(0, 0, 0) 2px -1px 7px inset",
      }}
    >
      <ul
        className="row pb-5 meanings"
        style={{
          backgroundImage: `url(${url})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          width: "80%",
          borderRadius: "55px",
          boxShadow:
            "rgba(170, 170, 175, 0.6) 5px 7px 21px, rgb(0, 0, 0) 1px 5px 12px ",
        }}
      >
        <div className="wordhead mt-4 ms-4 d-flex align-items-baseline">
          <h1 className="TheWord fw-bold">{capitalize(data.word)}</h1>
          <span className="phonetic ms-3 fst-italic">{data.phonetic}</span>
        </div>
        {data.meanings.map((definition, index) => (
          <div className="meaninglist" key={index}>
            <Meanings data={definition} />
          </div>
        ))}
      </ul>
    </div>
  );
}
